// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feed-container {
  width: 100%;
}

/* Community View Styles */
.community-view {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
}

/* Rich community header bar inside sticky wrapper */
.community-header-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  border-bottom: 1px solid var(--border-color);
  background-color: var(--bg-primary);
  min-height: 60px;
}

.community-header-bar-info {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.community-header-bar-title {
  font-size: 17px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  line-height: 1.3;
}

.community-header-bar-meta {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
}

.community-header-bar-slug {
  font-size: 12px;
  color: var(--text-secondary);
  font-weight: 500;
}

.community-header-bar-dot {
  font-size: 12px;
  color: var(--text-secondary);
  opacity: 0.5;
}

.community-header-bar-members {
  font-size: 12px;
  color: var(--accent-primary);
  font-weight: 600;
}

.community-header-subscribed-label {
  font-size: 10px;
  font-weight: 700;
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
  background: transparent;
  padding: 2px 6px;
  border-radius: 12px;
  margin-left: 4px;
  opacity: 0.7;
  display: inline-flex;
  align-items: center;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.community-about-info-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-secondary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 2px;
  line-height: 1;
  opacity: 0.7;
  transition: opacity 0.15s;
}

.community-about-info-btn:hover {
  opacity: 1;
}

/* Community about modal */
.community-about-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.community-about-modal {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 20px;
  max-width: 480px;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.community-about-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.community-about-modal-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: var(--text-primary);
}

.community-about-modal-close {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 50%;
  transition: background-color 0.15s;
}

.community-about-modal-close:hover {
  background: var(--hover-bg);
}

.community-about-modal-body {
  margin: 0;
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.6;
  white-space: pre-wrap;
}

.community-about-modal-rules {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--border-color);
}

.community-about-modal-rules-title {
  margin: 0 0 8px 0;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-secondary);
}

.community-header-bar-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.community-create-btn {
  padding: 6px 14px;
  background: var(--accent-primary);
  color: #fff;
  border: none;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
  transition: opacity 0.15s;
  display: inline-flex;
  align-items: center;
}

.community-create-btn:hover {
  opacity: 0.85;
}

/* Subscribe button — desktop only (inline in header) */
.community-subscribe-btn {
  padding: 6px 14px;
  background: transparent;
  color: var(--accent-primary);
  border: 1.5px solid var(--accent-primary);
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, color 0.15s, opacity 0.15s;
  display: inline-flex;
  align-items: center;
}

.community-subscribe-btn:hover:not(:disabled) {
  background: var(--accent-primary);
  color: #fff;
}

.community-subscribe-btn.subscribed {
  background: var(--bg-secondary);
  color: var(--text-secondary);
  border-color: var(--border-color);
}

.community-subscribe-btn.subscribed:hover:not(:disabled) {
  background: var(--error-bg, rgba(220,38,38,0.1));
  color: var(--error-color, #ef4444);
  border-color: var(--error-color, #ef4444);
}

.community-subscribe-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Desktop actions group (subscribe + post) — inside controls bar, desktop only */
.community-desktop-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

/* Mobile actions (⋯) — shown only on mobile, hidden on desktop */
.community-actions-menu {
  position: relative;
  display: none;
}

.community-actions-trigger {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  transition: background-color 0.2s;
  flex-shrink: 0;
}

.community-actions-trigger:hover {
  background: var(--hover-bg);
}

.community-actions-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.2);
  z-index: 200;
  min-width: 160px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.community-actions-item {
  display: block;
  width: 100%;
  text-align: left;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.15s;
  border-bottom: 1px solid var(--border-color);
}

.community-actions-item:last-child {
  border-bottom: none;
}

.community-actions-item:hover:not(:disabled) {
  background: var(--hover-bg);
}

.community-actions-item:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}


/* Responsive visibility */
@media (max-width: 768px) {
  .community-desktop-actions {
    display: none !important;
  }
  .community-actions-menu {
    display: block;
  }
  .mobile-only {
    display: flex !important;
  }
}

@media (min-width: 768.1px) {
  .community-actions-menu {
    display: none !important;
  }
}

/* Reuse SidebarHeader's menu button style */
.community-header-bar .menu-open-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transition: background-color 0.2s;
  flex-shrink: 0;
}

.community-header-bar .menu-open-btn:hover {
  background: var(--hover-bg);
}

@media (min-width: 768.7px) {
  .community-header-bar .menu-open-btn {
    display: none !important;
  }
}

.community-posts {
  background: var(--bg-primary);
}

/* Community sticky wrapper */
.community-stick {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: var(--bg-primary);
  backdrop-filter: blur(12px);
}

.App.header-layout .community-stick {
  top: 60px;
}

/* Override inner SidebarHeader stickiness — the wrapper handles it */
.community-stick .sidebar-header-bar {
  position: static;
  box-shadow: none;
}

/* Controls bar: sort tabs + pinned toggle */
.community-controls-bar {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  padding: 0 16px 0 4px;
  border-bottom: 1px solid var(--border-color);
  background-color: var(--bg-primary);
  gap: 8px;
}

/* The feed-tabs inside community uses the same tab styles as ShortFeed */
.community-controls-bar .feed-tabs {
  flex: 1 1;
  align-self: stretch;
}

.community-controls-bar .feed-tab {
  height: 100%;
}

.community-controls-bar .feed-tab.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.community-controls-bar .feed-tab.disabled:hover {
  background: none;
  color: var(--text-secondary);
}

/* Mobile sort dropdown */
.community-sort-dropdown {
  flex: 1 1;
  align-self: center;
  background: var(--bg-secondary);
  border: 1px solid var(--input-border);
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 600;
  padding: 8px 10px;
  cursor: pointer;
  height: auto;
}

/* App scope dropdown on the articles page */
.articles-app-dropdown {
  flex-shrink: 0;
  align-self: center;
  background: var(--bg-secondary);
  border: 1px solid var(--input-border);
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 600;
  padding: 8px 10px;
  cursor: pointer;
  height: auto;
}

/* Pinned toggle row */
.community-pinned-row {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 8px;
  padding: 6px 0;
  flex-shrink: 0;
}

.community-pinned-label {
  font-size: 13px;
  color: var(--text-secondary);
  text-align: end;
  max-width: 98px;
  padding-right:6px;
}

/* currency-toggle replicated for community pinned toggle */
.community-pinned-row.desktop-only .currency-toggle, .community-controls-bar .currency-toggle {
  position: relative;
  display: flex;
  align-items: center;
  width: 90px;
  padding: 4px;
  border-radius: 999px;
  border: 1px solid var(--input-border);
  background: var(--bg-secondary);
  cursor: pointer;
}

.community-pinned-row.desktop-only .currency-toggle .currency-option, .community-controls-bar .currency-toggle .currency-option {
  flex: 1 1;
  text-align: center;
  padding: 4px;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--text-secondary);
  z-index: 1;
}

.community-pinned-row.desktop-only .currency-toggle .currency-option.active, .community-controls-bar .currency-toggle .currency-option.active {
  color: var(--accent-primary);
}

.community-pinned-row.desktop-only .currency-toggle .currency-slider, .community-controls-bar .currency-toggle .currency-slider {
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 4px;
  width: calc(50% - 4px);
  background: var(--bg-primary);
  border-radius: 999px;
  box-shadow: 0 2px 8px var(--shadow-color);
  transition: transform 0.2s ease;
}

.community-pinned-row.desktop-only .currency-toggle.right .currency-slider, .community-controls-bar .currency-toggle.right .currency-slider {
  right: 0;
  
  transform: translateX(100%);
}

.no-posts {
  padding: 60px 20px;
  text-align: center;
}

.no-posts p {
  color: var(--text-secondary);
  font-size: 15px;
  margin: 0;
}

.create-article-btn {
  padding: 10px 24px;
  background: var(--primary-color);
  color: var(--text-primary);
  border: none;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.create-article-btn:hover {
  background: var(--primary-hover);
}

.error-message {
  padding: 20px;
  text-align: center;
  color: var(--error-color);
}

.feed-title {
  font-size: 1.5rem;
  margin-bottom: 20px;
  color: var(--text-primary);
}

.loading {
  text-align: center;
  /*padding: 40px;*/
  color: var(--text-secondary);
  font-size: 1.1rem;
}

.error-box {
  background: var(--error-bg);
  border: 1px solid var(--error-color);
  border-radius: 12px;
  padding: 20px;
  margin: 20px 0;
  text-align: center;
}

.error-box p {
  color: var(--error-color);
  margin-bottom: 12px;
}

.retry-btn {
  padding: 10px 20px;
  background: var(--accent-primary);
  color: white;
  border: none;
  border-radius: 20px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.retry-btn:hover {
  background: var(--accent-hover);
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: var(--text-secondary);
}

.empty-state h2 {
  margin-bottom: 10px;
  color: var(--text-primary);
}

.empty-state p {
  font-size: 1.1rem;
}

.posts-list {
  display: flex;
  flex-direction: column;
}

.load-more-container {
  display: flex;
  justify-content: center;
  margin: 30px 0;
  padding: 0 20px;
}

.load-more-btn {
  padding: 12px 32px;
  background: var(--accent-primary);
  color: white;
  border: none;
  border-radius: 24px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px var(--shadow-color);
}

.load-more-btn:hover:not(:disabled) {
  background: var(--accent-hover);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px var(--shadow-color);
}

.load-more-btn:disabled {
  background: var(--text-tertiary);
  cursor: not-allowed;
  box-shadow: none;
}

.end-message {
  text-align: center;
  padding: 20px;
  margin: 20px 0;
  color: var(--text-secondary);
  font-size: 14px;
  font-style: italic;
}

@media (max-width: 768px) {
  .feed-title {
    font-size: 1.3rem;
    margin-bottom: 15px;
  }

  .empty-state {
    padding: 40px 15px;
  }
  
  .load-more-btn {
    padding: 10px 24px;
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Feed.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,4CAA4C;EAC5C,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,qCAAqC;EACrC,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,uDAAuD;AACvD;EACE,iBAAiB;EACjB,uBAAuB;EACvB,4BAA4B;EAC5B,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,wDAAwD;EACxD,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,gDAAgD;EAChD,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;;AAGA,0BAA0B;AAC1B;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,cAAc;EAChB;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,4CAA4C;AAC5C;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,SAAS;AACX;;AAEA,qEAAqE;AACrE;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;EAC9B,qBAAqB;EACrB,4CAA4C;EAC5C,mCAAmC;EACnC,QAAQ;AACV;;AAEA,yEAAyE;AACzE;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,yBAAyB;AACzB;EACE,SAAO;EACP,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA,4CAA4C;AAC5C;EACE,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;EACpB,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,QAAQ;;EAER,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":[".feed-container {\r\n  width: 100%;\r\n}\r\n\r\n/* Community View Styles */\r\n.community-view {\r\n  width: 100%;\r\n  max-width: 800px;\r\n  margin: 0 auto;\r\n}\r\n\r\n/* Rich community header bar inside sticky wrapper */\r\n.community-header-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 10px 16px;\r\n  border-bottom: 1px solid var(--border-color);\r\n  background-color: var(--bg-primary);\r\n  min-height: 60px;\r\n}\r\n\r\n.community-header-bar-info {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.community-header-bar-title {\r\n  font-size: 17px;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin: 0;\r\n  line-height: 1.3;\r\n}\r\n\r\n.community-header-bar-meta {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.community-header-bar-slug {\r\n  font-size: 12px;\r\n  color: var(--text-secondary);\r\n  font-weight: 500;\r\n}\r\n\r\n.community-header-bar-dot {\r\n  font-size: 12px;\r\n  color: var(--text-secondary);\r\n  opacity: 0.5;\r\n}\r\n\r\n.community-header-bar-members {\r\n  font-size: 12px;\r\n  color: var(--accent-primary);\r\n  font-weight: 600;\r\n}\r\n\r\n.community-header-subscribed-label {\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  color: var(--text-secondary);\r\n  border: 1px solid var(--border-color);\r\n  background: transparent;\r\n  padding: 2px 6px;\r\n  border-radius: 12px;\r\n  margin-left: 4px;\r\n  opacity: 0.7;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n}\r\n\r\n.community-about-info-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: var(--text-secondary);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0 2px;\r\n  line-height: 1;\r\n  opacity: 0.7;\r\n  transition: opacity 0.15s;\r\n}\r\n\r\n.community-about-info-btn:hover {\r\n  opacity: 1;\r\n}\r\n\r\n/* Community about modal */\r\n.community-about-modal-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  z-index: 1000;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 20px;\r\n}\r\n\r\n.community-about-modal {\r\n  background: var(--bg-primary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  max-width: 480px;\r\n  width: 100%;\r\n  max-height: 80vh;\r\n  overflow-y: auto;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.community-about-modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.community-about-modal-header h3 {\r\n  margin: 0;\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.community-about-modal-close {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: var(--text-secondary);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 4px;\r\n  border-radius: 50%;\r\n  transition: background-color 0.15s;\r\n}\r\n\r\n.community-about-modal-close:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.community-about-modal-body {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  color: var(--text-secondary);\r\n  line-height: 1.6;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.community-about-modal-rules {\r\n  margin-top: 16px;\r\n  padding-top: 16px;\r\n  border-top: 1px solid var(--border-color);\r\n}\r\n\r\n.community-about-modal-rules-title {\r\n  margin: 0 0 8px 0;\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.community-header-bar-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.community-create-btn {\r\n  padding: 6px 14px;\r\n  background: var(--accent-primary);\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 20px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n  white-space: nowrap;\r\n  transition: opacity 0.15s;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.community-create-btn:hover {\r\n  opacity: 0.85;\r\n}\r\n\r\n/* Subscribe button — desktop only (inline in header) */\r\n.community-subscribe-btn {\r\n  padding: 6px 14px;\r\n  background: transparent;\r\n  color: var(--accent-primary);\r\n  border: 1.5px solid var(--accent-primary);\r\n  border-radius: 20px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n  transition: background 0.15s, color 0.15s, opacity 0.15s;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.community-subscribe-btn:hover:not(:disabled) {\r\n  background: var(--accent-primary);\r\n  color: #fff;\r\n}\r\n\r\n.community-subscribe-btn.subscribed {\r\n  background: var(--bg-secondary);\r\n  color: var(--text-secondary);\r\n  border-color: var(--border-color);\r\n}\r\n\r\n.community-subscribe-btn.subscribed:hover:not(:disabled) {\r\n  background: var(--error-bg, rgba(220,38,38,0.1));\r\n  color: var(--error-color, #ef4444);\r\n  border-color: var(--error-color, #ef4444);\r\n}\r\n\r\n.community-subscribe-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Desktop actions group (subscribe + post) — inside controls bar, desktop only */\r\n.community-desktop-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Mobile actions (⋯) — shown only on mobile, hidden on desktop */\r\n.community-actions-menu {\r\n  position: relative;\r\n  display: none;\r\n}\r\n\r\n.community-actions-trigger {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: var(--text-primary);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 50%;\r\n  transition: background-color 0.2s;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.community-actions-trigger:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.community-actions-dropdown {\r\n  position: absolute;\r\n  top: calc(100% + 6px);\r\n  right: 0;\r\n  background: var(--bg-primary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 10px;\r\n  box-shadow: 0 8px 24px rgba(0,0,0,0.2);\r\n  z-index: 200;\r\n  min-width: 160px;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.community-actions-item {\r\n  display: block;\r\n  width: 100%;\r\n  text-align: left;\r\n  padding: 12px 16px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: var(--text-primary);\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n  transition: background 0.15s;\r\n  border-bottom: 1px solid var(--border-color);\r\n}\r\n\r\n.community-actions-item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.community-actions-item:hover:not(:disabled) {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.community-actions-item:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n\r\n/* Responsive visibility */\r\n@media (max-width: 768px) {\r\n  .community-desktop-actions {\r\n    display: none !important;\r\n  }\r\n  .community-actions-menu {\r\n    display: block;\r\n  }\r\n  .mobile-only {\r\n    display: flex !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 768.1px) {\r\n  .community-actions-menu {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n/* Reuse SidebarHeader's menu button style */\r\n.community-header-bar .menu-open-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: var(--text-primary);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  transition: background-color 0.2s;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.community-header-bar .menu-open-btn:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n@media (min-width: 768.7px) {\r\n  .community-header-bar .menu-open-btn {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n.community-posts {\r\n  background: var(--bg-primary);\r\n}\r\n\r\n/* Community sticky wrapper */\r\n.community-stick {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 100;\r\n  background-color: var(--bg-primary);\r\n  backdrop-filter: blur(12px);\r\n}\r\n\r\n.App.header-layout .community-stick {\r\n  top: 60px;\r\n}\r\n\r\n/* Override inner SidebarHeader stickiness — the wrapper handles it */\r\n.community-stick .sidebar-header-bar {\r\n  position: static;\r\n  box-shadow: none;\r\n}\r\n\r\n/* Controls bar: sort tabs + pinned toggle */\r\n.community-controls-bar {\r\n  display: flex;\r\n  align-items: stretch;\r\n  justify-content: space-between;\r\n  padding: 0 16px 0 4px;\r\n  border-bottom: 1px solid var(--border-color);\r\n  background-color: var(--bg-primary);\r\n  gap: 8px;\r\n}\r\n\r\n/* The feed-tabs inside community uses the same tab styles as ShortFeed */\r\n.community-controls-bar .feed-tabs {\r\n  flex: 1;\r\n  align-self: stretch;\r\n}\r\n\r\n.community-controls-bar .feed-tab {\r\n  height: 100%;\r\n}\r\n\r\n.community-controls-bar .feed-tab.disabled {\r\n  opacity: 0.4;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.community-controls-bar .feed-tab.disabled:hover {\r\n  background: none;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n/* Mobile sort dropdown */\r\n.community-sort-dropdown {\r\n  flex: 1;\r\n  align-self: center;\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--input-border);\r\n  border-radius: 8px;\r\n  color: var(--text-primary);\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  padding: 8px 10px;\r\n  cursor: pointer;\r\n  height: auto;\r\n}\r\n\r\n/* App scope dropdown on the articles page */\r\n.articles-app-dropdown {\r\n  flex-shrink: 0;\r\n  align-self: center;\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--input-border);\r\n  border-radius: 8px;\r\n  color: var(--text-primary);\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  padding: 8px 10px;\r\n  cursor: pointer;\r\n  height: auto;\r\n}\r\n\r\n/* Pinned toggle row */\r\n.community-pinned-row {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: row;\r\n  gap: 8px;\r\n  padding: 6px 0;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.community-pinned-label {\r\n  font-size: 13px;\r\n  color: var(--text-secondary);\r\n  text-align: end;\r\n  max-width: 98px;\r\n  padding-right:6px;\r\n}\r\n\r\n/* currency-toggle replicated for community pinned toggle */\r\n.community-pinned-row.desktop-only .currency-toggle, .community-controls-bar .currency-toggle {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  width: 90px;\r\n  padding: 4px;\r\n  border-radius: 999px;\r\n  border: 1px solid var(--input-border);\r\n  background: var(--bg-secondary);\r\n  cursor: pointer;\r\n}\r\n\r\n.community-pinned-row.desktop-only .currency-toggle .currency-option, .community-controls-bar .currency-toggle .currency-option {\r\n  flex: 1;\r\n  text-align: center;\r\n  padding: 4px;\r\n  font-size: 0.82rem;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n  z-index: 1;\r\n}\r\n\r\n.community-pinned-row.desktop-only .currency-toggle .currency-option.active, .community-controls-bar .currency-toggle .currency-option.active {\r\n  color: var(--accent-primary);\r\n}\r\n\r\n.community-pinned-row.desktop-only .currency-toggle .currency-slider, .community-controls-bar .currency-toggle .currency-slider {\r\n  position: absolute;\r\n  top: 4px;\r\n  bottom: 4px;\r\n  left: 4px;\r\n  width: calc(50% - 4px);\r\n  background: var(--bg-primary);\r\n  border-radius: 999px;\r\n  box-shadow: 0 2px 8px var(--shadow-color);\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.community-pinned-row.desktop-only .currency-toggle.right .currency-slider, .community-controls-bar .currency-toggle.right .currency-slider {\r\n  right: 0;\r\n  \r\n  transform: translateX(100%);\r\n}\r\n\r\n.no-posts {\r\n  padding: 60px 20px;\r\n  text-align: center;\r\n}\r\n\r\n.no-posts p {\r\n  color: var(--text-secondary);\r\n  font-size: 15px;\r\n  margin: 0;\r\n}\r\n\r\n.create-article-btn {\r\n  padding: 10px 24px;\r\n  background: var(--primary-color);\r\n  color: var(--text-primary);\r\n  border: none;\r\n  border-radius: 20px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.create-article-btn:hover {\r\n  background: var(--primary-hover);\r\n}\r\n\r\n.error-message {\r\n  padding: 20px;\r\n  text-align: center;\r\n  color: var(--error-color);\r\n}\r\n\r\n.feed-title {\r\n  font-size: 1.5rem;\r\n  margin-bottom: 20px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.loading {\r\n  text-align: center;\r\n  /*padding: 40px;*/\r\n  color: var(--text-secondary);\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.error-box {\r\n  background: var(--error-bg);\r\n  border: 1px solid var(--error-color);\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  margin: 20px 0;\r\n  text-align: center;\r\n}\r\n\r\n.error-box p {\r\n  color: var(--error-color);\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.retry-btn {\r\n  padding: 10px 20px;\r\n  background: var(--accent-primary);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 20px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.retry-btn:hover {\r\n  background: var(--accent-hover);\r\n}\r\n\r\n.empty-state {\r\n  text-align: center;\r\n  padding: 60px 20px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.empty-state h2 {\r\n  margin-bottom: 10px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.empty-state p {\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.posts-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.load-more-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin: 30px 0;\r\n  padding: 0 20px;\r\n}\r\n\r\n.load-more-btn {\r\n  padding: 12px 32px;\r\n  background: var(--accent-primary);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 24px;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  box-shadow: 0 2px 4px var(--shadow-color);\r\n}\r\n\r\n.load-more-btn:hover:not(:disabled) {\r\n  background: var(--accent-hover);\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 8px var(--shadow-color);\r\n}\r\n\r\n.load-more-btn:disabled {\r\n  background: var(--text-tertiary);\r\n  cursor: not-allowed;\r\n  box-shadow: none;\r\n}\r\n\r\n.end-message {\r\n  text-align: center;\r\n  padding: 20px;\r\n  margin: 20px 0;\r\n  color: var(--text-secondary);\r\n  font-size: 14px;\r\n  font-style: italic;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .feed-title {\r\n    font-size: 1.3rem;\r\n    margin-bottom: 15px;\r\n  }\r\n\r\n  .empty-state {\r\n    padding: 40px 15px;\r\n  }\r\n  \r\n  .load-more-btn {\r\n    padding: 10px 24px;\r\n    font-size: 14px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
